<template>
  <div class="requirement-files">
    <div 
      v-if="files.length === 0"
      class="no-files-message"
    >
      <p>No {{ formatFileType(fileType) }} files uploaded yet.</p>
    </div>
    <div 
      v-else
      class="files-list"
    >
      <div 
        v-for="file in files" 
        :key="file.id || file.file_id"
        class="file-item"
      >
        <div class="file-icon-small">
          <i :class="getFileIcon(file)"></i>
        </div>
        <div class="file-details">
          <div class="file-name-small">{{ formatFileName(file.name) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RequirementFilesList',
  props: {
    files: {
      type: Array,
      required: true,
      default: () => []
    },
    fileType: {
      type: String,
      required: true
    }
  },
  methods: {
    getFileIcon(file) {
      const documentType = file.document_type || file.type;
      
      switch (documentType) {
        case 'application/pdf':
        case 'pdf':
          return 'las la-file-pdf';
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        case 'excel':
        case 'xlsx':
        case 'xls':
          return 'las la-file-excel';
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        case 'word':
        case 'doc':
        case 'docx':
          return 'las la-file-word';
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
        case 'powerpoint':
        case 'ppt':
        case 'pptx':
          return 'las la-file-powerpoint';
        case 'text/csv':
        case 'csv':
          return 'las la-file-csv';
        case 'application/json':
        case 'json':
          return 'las la-file-code';
        case 'image/jpeg':
        case 'image/png':
        case 'image/gif':
        case 'image':
          return 'las la-file-image';
        default:
          return 'las la-file-alt';
      }
    },
    
    formatFileName(name) {
      if (!name) return 'Unknown File';
      return name.split('.')[0];
    },
    
    formatFileType(type) {
      switch (type) {
        case 'bank_statement':
          return 'Bank Statement';
        case 'emirates_id':
          return 'Emirates ID';
        case 'trade_license':
        case 'trade_licence':
          return 'Trade License';
        case 'vat_statement':
          return 'VAT Statement';
        case 'aecb_report':
          return 'AECB Report';
        case 'payer_list':
          return 'Payer List';
        case 'credit_model':
          return 'Credit Model';
        default:
          return type || 'Unknown';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../index.scss';

.requirement-files {
  border-top: 1px solid #e2e8f0;
  padding: 0.75rem;
  background: #ffffff;
  max-height: 200px;
  overflow-y: auto;
  
  .no-files-message {
    text-align: center;
    padding: 1rem 0.5rem;
    color: #718096;
    
    p {
      margin: 0;
      font-size: 0.85rem;
    }
  }
  
  .files-list {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .file-item {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.5rem;
    border-radius: 6px;
    background: #f7fafc;
    transition: all 0.2s ease;
    
    &:hover {
      background: #edf2f7;
    }
    
    .file-icon-small {
      i {
        font-size: 1.25rem;
        color: $color-primary;
        opacity: 0.8;
      }
    }
    
    .file-details {
      flex: 1;
      
      .file-name-small {
        font-size: 0.85rem;
        font-weight: 500;
        color: #2d3748;
        margin: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  
  /* ===== Scrollbar CSS ===== */
  /* Firefox */
  scrollbar-width: auto;
  scrollbar-color: #ddd #ffffff;

  /* Chrome, Edge, and Safari */
  &::-webkit-scrollbar {
    width: 16px;
  }

  &::-webkit-scrollbar-track {
    background: #ffffff;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #54a06f;
    border-radius: 10px;
    border: 3px solid #ffffff;
  }
}
</style>

